<style>
.edi-register {
	height: 100%;
	background-color: #eee;
}
.edi-register .fieldset-1 {
	margin-top: 3em !important;
}
.ui-content .ui-listview-inset {
	margin: 1em 0;
	-webkit-border-radius: .3125em;
	border-radius: .3125em;
}
.ui-btn {
	cursor: pointer;
	padding: .3em .8em;
	margin-right: .3em;
}
</style>

<template>
	<div class="edi-register">
		<navbar title="用户注册"></navbar>
		<form class="ui-content" @submit.prevent="register">
			<ul class="ui-listview ui-listview-inset">
				<li class="ui-listview-first-item"><input type="text" name="company" v-model="company" placeholder="企业名称"/></li>
				<li><input type="text" name="telephone" v-model="telephone" placeholder="手机号"/></li>
				<li style="display: flex">
					<input type="text" name="verifyCode" v-model="verifyCode" placeholder="图形验证码" />
					<img :src="verifyCodeImg" @click="refreshVerifyCodeClick" style="height: 36px" />
				</li>
				<li class="ui-listview-last-item">
					<div class="ui-col-6"><input type="text" name="code" v-model="code" placeholder="验证码"/></div
					><div class="ui-col-4 ui-align-right"><mobile-code :type="1" :mobile="telephone" :verifyCode="verifyCode" :uuid="verifyUUID" @on-refresh="refreshVerifyCodeClick"></mobile-code></div>
				</li>
			</ul>
			<fieldset class="ui-controlgroup">
				<input type="submit" v-if="disabled" value="注册" disabled="true" class="ui-btn-disable" />
				<input type="submit" v-else value="注册" class="submit"/>
			</fieldset>
		</form>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont="tipsFont"></tips-auto>
	</div>
</template>

<script>
import MobileCode from '../components/MobileCode'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'

export default {
	data () {
		return {
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			disabled: false,
			company: '',
			telephone: '',
			code: '',
			// patrn: /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/,
			patrn: /^(\d{11})$/,
			codePatrn: /^\d{4}$/,
			chinesePatrn: /^[\u2E80-\u9FFF]+$/,
			sec: 1500,
			verifyCode: '',
			verifyUUID: this.$fxUtils.createUUID()
		}
	},
	computed: {
		submitDisable () {
			return !this.code
		},
		verifyCodeImg () {
			return `/cldEdi/business/${this.verifyUUID}/getVerifyCode`
		}
	},
	components: {
		'mobile-code': MobileCode,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'navbar': NavBar
	},
	methods: {
		refreshVerifyCodeClick () {
			this.verifyUUID = this.$fxUtils.createUUID()
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			this.tipsauto = true
			this.tipsFont = msg
			setTimeout(() => {
				this.tipsauto = false
			}, this.sec)
		},
		delaySkip (path) {
			var self = this
			setTimeout(() => {
				this.$router.push({path: path})
			}, self.sec)
		},
		register () {
			if (this.company === '') {
				this.autoTips('企业名称不能为空')
				return false
			} else if (!(this.chinesePatrn.test(this.company))) {
				this.autoTips('企业名称只能是汉字')
				return false
			} else if (this.company.length > 30) {
				this.autoTips('企业名称最大长度为30个字符')
				return false
			}
			if (this.telephone === '') {
				this.autoTips('手机号码不能为空')
				return false
			} else if (!(this.patrn.test(this.telephone))) {
				this.autoTips('手机号码格式不正确')
				return false
			}
			if (this.sendSms) {
				if (this.code === '') {
					this.autoTips('验证码不能为空')
					return false
				} else if (!(this.codePatrn.test(this.code))) {
					this.autoTips('验证码为四位数字')
					return false
				}
			}
			this.registerPost()
		},
		registerPost () {
			var obj = {
				company: this.company,
				telephone: this.telephone,
				code: this.code
			}
			this.$http.post('/cldEdi/business/register', obj).then((response) => {
				var data = response.body
				if (!data.result) {
					this.autoTips(data.message)
					return false
				} else {
					this.autoTips('注册成功')
					this.delaySkip('/main/home')
				}
			})
		}
	},
	created () {
	}
}
</script>



// WEBPACK FOOTER //
// Register.vue?433069ac